
import { ViewerScene } from '../ViewerScene';
import { ViewerTool } from './ViewerBaseTool'
import * as THREE from 'three';
import { Viewer } from '../Viewer';
import { TransformControls } from 'three/examples/jsm/controls/TransformControls';
import { SVGOverlay } from "../Overlays/SVGOverlay";
import { Overlay } from '../Overlays/Overlay'
import { SceneLayerName } from '../../hsbcad-model';
import { Wireframe } from 'three/examples/jsm/lines/Wireframe';
import { Picker, SnapGeometry } from './Picker';
import { ViewerLayers, ViewerLayersBit } from '../Enums/ViewerLayers';


export type SectionData = { position: THREE.Vector3, quaternion: THREE.Quaternion, transformMode: "translate" | "rotate" | "scale" }
export class SectionTool extends ViewerTool {


    private _picker: Picker;
    PlacedSection: boolean = false;

    get _SVGOverlay(): SVGOverlay { return this._viewer?.SVGOverlay; }
    get _Overlay(): Overlay { return this._viewer?.Overlay; }

    private _clippingPlaneMesh: THREE.Mesh;
    private _clippingPlane: THREE.Plane;
    private _transControls!: TransformControls;
    private _showWireframe: boolean;

    private draggingChanged(event: any) {
        if (!this._viewer?.currentControls || !this._viewer?.ViewerEvents)
            return;
        this._viewer.currentControls.enabled = !event.value;
        this._viewer.ViewerEvents.enabled = !event.value;
    }

    private change(event: any) {
        this.UpdatePlaneAndControls();
        
    }

    private transformMode: "translate" | "rotate" | "scale";
    public get TransformMode() {
        return this.transformMode;
    }
    private _visible: boolean = false;
    public get visible(): boolean {
        return this._visible;
    }


    constructor(viewer: Viewer) {
        super(viewer);
        this.Tool = "Section";
        this._picker = this._viewer._picker;

        this._clippingPlane = new THREE.Plane();

        let planeGeom = new THREE.PlaneGeometry(10000, 10000);
        let trans = new THREE.MeshPhongMaterial({ color: 0xffffff, side: THREE.DoubleSide, opacity: 0.5, transparent: true });
        this._clippingPlaneMesh = new THREE.Mesh(planeGeom, trans);
        this._clippingPlaneMesh.layers.set(ViewerLayers.TOOLS);

        this._clippingPlaneMesh.visible = false;

        let forward = new THREE.Vector3(0, 0, 1).applyMatrix4(this._clippingPlaneMesh.matrixWorld.extractRotation(new THREE.Matrix4()));
        this._clippingPlane.setFromNormalAndCoplanarPoint(forward, this._clippingPlaneMesh.position);

        this._showWireframe = false;
        this.transformMode = "translate";

        if (!this._viewer.currentCamera)
            return this;
        this._transControls = new TransformControls(this._viewer.currentCamera, this._viewer._renderer.domElement);
        /**
         * @todo : https://github.com/mrdoob/three.js/pull/11312#issuecomment-597796298 Currently seting layer for controls is not supported in THREE.js (r 124)
         */
        //this._transControls.layers.enable(ViewerLayers.TOOLS);
        //this._transControls.traverse((c)=>c.layers.enable(ViewerLayers.TOOLS));

        this._transControls.enabled = false;
        this._transControls.visible = false;
        this._transControls.space = "local";
        this._viewer._renderer.localClippingEnabled = true;
    }

    Activate() {
        this._transControls.addEventListener('dragging-changed', this.draggingChanged.bind(this));
        this._transControls.addEventListener('change', this.change.bind(this));
        this._clippingPlaneMesh.updateMatrix();
        this._transControls.updateMatrix();
        this._visible = true;
        this._transControls.visible = true;
        this._transControls.enabled = true;
        this._transControls.showX = false;
        this._transControls.showY = false;
        this._clippingPlaneMesh.visible = true;
        this.PlacedSection =false;
        this.UpdatePlaneAndControls();
        
    }

    Deactivate() {
        this._Overlay.clearMenu();
        this._visible = false;
        this._transControls.removeEventListener('dragging-changed', this.draggingChanged);

        this._transControls.removeEventListener('change', this.change);
        this._transControls.enabled = false;
        this._transControls.visible = false;
        this.SetClippingPlaneForScene(false);
        this._clippingPlaneMesh.visible = false;
        this._viewer.requestRenderFrame();
    }

    cleanUp() {
        if (this._transControls) {
            this._transControls.traverse((child: any) => {
                child.geometry?.dispose();
                if (child.material)
                    Array.isArray(child.material) ? child.material.forEach((mat: any) => mat.dispose()) : child.material.dispose();
                child.dispose?.();
            });
            this._transControls.detach();
        }
        this._clippingPlaneMesh?.geometry?.dispose();
        Array.isArray(this._clippingPlaneMesh.material) ? this._clippingPlaneMesh.material.forEach((mat) => mat.dispose()) : this._clippingPlaneMesh.material.dispose();
    }



    SetScene(scene: ViewerScene) {
        this._visible = false;
        // Old scene
        this.SetClippingPlaneForScene(false);
        this._viewer.currentScene?.remove(this._clippingPlaneMesh, this._transControls);
        // New scene
        scene.add(this._clippingPlaneMesh, this._transControls);
        // Mesh setup for new scene
        this._clippingPlaneMesh.visible = false;

        // Controls setup for new scene
        if (scene.currentCamera)
            this._transControls.camera = scene.currentCamera;
        this._transControls.attach(this._clippingPlaneMesh);
        this._transControls.enabled = false;
        this._transControls.visible = false;
        this._transControls.updateMatrix();

        this.PlacedSection = false;

    }
    OnPointerMove(coords: THREE.Vector2, type: string): void {
        if (!this.PlacedSection) {
            let rayRequest = this._picker.requestRaycast(coords, { layer: ViewerLayersBit.MODELS, snapGeometry: SnapGeometry.FACE });
            /**
            * @todo : https://github.com/mrdoob/three.js/pull/11312#issuecomment-597796298 Currently seting layer for controls is not supported in THREE.js (r 124)
            * This is a temporary fix to prevent the raycast hitting the transformcontrol planes.
            */
            if (!rayRequest)
                return;
            let quat = new THREE.Quaternion();
            if (rayRequest?.point) {
                let normal = rayRequest.normal;
                let rotM4 = new THREE.Matrix4().lookAt(new THREE.Vector3(), normal, new THREE.Vector3(0, 1, 0));
                quat = quat.setFromRotationMatrix(rotM4);
                this._clippingPlaneMesh.quaternion.copy(quat);
                this._clippingPlaneMesh.position.copy(rayRequest.point);
            }
            this.UpdatePlaneAndControls();

        }
    }

    onPrimaryDown(coords: THREE.Vector2) {
        if (!this.PlacedSection) {
            this._transControls.visible = true;
            this._transControls.enabled = true;
            this.PlacedSection = true;
            this.SetClippingPlaneForScene(true);
        }

    }
    onSecondaryDown(coords: THREE.Vector2) {
        this.ResetSection();
    }
    OnKeyPressed(keycode: string): void {
        switch (keycode) {
            case 'ShiftLeft':
            case 'ShiftRight':
                this._transControls.setTranslationSnap(100);
                this._transControls.setRotationSnap(THREE.MathUtils.degToRad(45));
                this._transControls.setScaleSnap(0.25);
                break;

        }
    }
    OnKeyReleased(keycode: string): void {
        switch (keycode) {
            case 'ShiftLeft':
            case 'ShiftRight':
                this._transControls.setTranslationSnap(null);
                this._transControls.setRotationSnap(null);
                this._transControls.setScaleSnap(null);
                break;

        }
    }

    /**
     * Assigns the clipping plane for all entites and if enabled for the wireframes aswell.
     * @param state If true will apply the clipping plane.
     */
    SetClippingPlaneForScene(state: boolean, scene?: ViewerScene | null) {
        if (!scene)
            scene = this._viewer.currentScene;
        if (!scene)
            return;
        let self = this;
        let layer: THREE.Object3D = scene._hsbLayers[SceneLayerName.Entities];
        layer?.traverse((object) => {
            if ((object instanceof THREE.Mesh || object instanceof THREE.Sprite || object instanceof THREE.Line) && object.material) {
                if (state) {

                    object.material.clippingPlanes = [self._clippingPlane]
                    object.material.onBeforeCompile = function (shader : any) {
                        // Setting shader to fake caps
                        shader.fragmentShader = shader.fragmentShader.replace(
                            `gl_FragColor = vec4( outgoingLight, diffuseColor.a );`,
                            `gl_FragColor = ( gl_FrontFacing ) ? vec4( outgoingLight, diffuseColor.a ) : vec4( diffuse, opacity );`
                        );
                    };
                }
                else {
                    object.material.clippingPlanes = []
                    object.material.onBeforeCompile = function (shader: any) {
                        // Resetting shader
                        shader.fragmentShader = shader.fragmentShader.replace(
                            `gl_FragColor = ( gl_FrontFacing ) ? vec4( outgoingLight, diffuseColor.a ) : vec4( diffuse, opacity );`,
                            `gl_FragColor = vec4( outgoingLight, diffuseColor.a );`
                        );
                    };
                }
            }


            if (object instanceof Wireframe && object.material) {
                if (Array.isArray(object.material)) {
                    object.material.forEach(material => {
                        if (state && !this._showWireframe)
                            material.clippingPlanes = [self._clippingPlane]
                        else
                            material.clippingPlanes = []
                    });
                }
                else {
                    if (state && !this._showWireframe)
                        object.material.clippingPlanes = [self._clippingPlane]
                    else
                        object.material.clippingPlanes = []
                }

            }

        })

    }

    ToggleSection() {
        this._visible = !this._visible;
        this.SetClippingPlaneForScene(this._visible);
    }

    FlipSection() {
        this._clippingPlaneMesh.rotateX(Math.PI);
        this.UpdatePlaneAndControls()
    }

    UpdatePlaneAndControls() {
        this._transControls.updateMatrixWorld();
        this._transControls.updateMatrix();
        let forward = new THREE.Vector3(0, 0, 1).applyQuaternion(this._clippingPlaneMesh.quaternion);
        this._clippingPlane.setFromNormalAndCoplanarPoint(forward, this._clippingPlaneMesh.position);
        this._viewer.requestRenderFrame();
    }

    ResetSection() {
        this.PlacedSection = false;
        this.SetClippingPlaneForScene(false);
        this._transControls.enabled = true;
        this._transControls.visible = true;
    }

    Cancel() {
        this.ResetSection();
        this._viewer.SetNoTool();
    }

    SetControlMode(mode: "translate" | "rotate" | "scale") {
        this._transControls.setMode(mode);
        this.transformMode = mode;
        switch (mode) {
            case 'translate': this._transControls.showX = this._transControls.showY = false; this._transControls.showZ = true; break;
            case 'rotate': this._transControls.showX = this._transControls.showY = true; this._transControls.showZ = false; break;
        }

    }

    getData(): SectionData {
        return {
            position: this._clippingPlaneMesh.position.clone(),
            quaternion: this._clippingPlaneMesh.quaternion.clone(),
            transformMode: this.transformMode
        }
    }

    placeFromData(data: SectionData) {
        this._visible = true;
        this.PlacedSection = true;
        this._clippingPlaneMesh.position.copy(data.position);
        this._clippingPlaneMesh.quaternion.copy(data.quaternion);
        this.SetControlMode(data.transformMode);
        this.SetClippingPlaneForScene(true);
        this.UpdatePlaneAndControls();
    }
}